package example.mystybag.db.database

import app.cash.sqldelight.TransacterImpl
import app.cash.sqldelight.db.AfterVersion
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlDriver
import app.cash.sqldelight.db.SqlSchema
import example.mystybag.db.MystyBagRoomDatabase
import kotlin.Long
import kotlin.Unit
import kotlin.reflect.KClass
import mobile.icard.ICardRoomDatabase.ContactImageLinksQueries
import mobile.icard.ICardRoomDatabase.EmbeddingsQueries

internal val KClass<MystyBagRoomDatabase>.schema: SqlSchema<QueryResult.Value<Unit>>
  get() = MystyBagRoomDatabaseImpl.Schema

internal fun KClass<MystyBagRoomDatabase>.newInstance(driver: SqlDriver): MystyBagRoomDatabase =
    MystyBagRoomDatabaseImpl(driver)

private class MystyBagRoomDatabaseImpl(
  driver: SqlDriver,
) : TransacterImpl(driver), MystyBagRoomDatabase {
  override val contactImageLinksQueries: ContactImageLinksQueries = ContactImageLinksQueries(driver)

  override val embeddingsQueries: EmbeddingsQueries = EmbeddingsQueries(driver)

  public object Schema : SqlSchema<QueryResult.Value<Unit>> {
    override val version: Long
      get() = 1

    override fun create(driver: SqlDriver): QueryResult.Value<Unit> {
      driver.execute(null, """
          |CREATE TABLE contact_image_links (
          |    wallet_id   INTEGER PRIMARY KEY NOT NULL,
          |    contact_id  TEXT,
          |    link        TEXT,
          |    name        TEXT,
          |    name_search TEXT,
          |    last_ts     INTEGER NOT NULL DEFAULT 0
          |)
          """.trimMargin(), 0)
      driver.execute(null, """
          |CREATE TABLE embeddings (
          |  merchantLocationId INTEGER NOT NULL,
          |  cityId INTEGER NOT NULL,
          |  lang TEXT NOT NULL,
          |  docType TEXT NOT NULL,               -- "LOC" / "CAT"
          |  qScale REAL NOT NULL,
          |  qZeroPoint INTEGER NOT NULL,
          |  vecQint8 BLOB NOT NULL,              -- 384 bytes
          |  lastModifiedIso TEXT NOT NULL DEFAULT '',
          |  PRIMARY KEY (merchantLocationId, docType)
          |)
          """.trimMargin(), 0)
      driver.execute(null,
          "CREATE INDEX contact_links_id_index ON contact_image_links (contact_id)", 0)
      driver.execute(null, "CREATE INDEX embeddings_cityId_idx ON embeddings(cityId)", 0)
      driver.execute(null, "CREATE INDEX embeddings_lang_idx ON embeddings(lang)", 0)
      driver.execute(null, "CREATE INDEX embeddings_docType_idx ON embeddings(docType)", 0)
      driver.execute(null,
          "CREATE INDEX embeddings_city_docType_idx ON embeddings(cityId, docType)", 0)
      return QueryResult.Unit
    }

    override fun migrate(
      driver: SqlDriver,
      oldVersion: Long,
      newVersion: Long,
      vararg callbacks: AfterVersion,
    ): QueryResult.Value<Unit> = QueryResult.Unit
  }
}
